import React from "react";
import {Navigate, Route, Routes, useLocation} from 'react-router-dom';
import Logout from "./components/Logout/Logout";
import Home from "./pages/Home";
import ProjectPlan from "./pages/ProjectPlan";
import Administration from "./pages/Administration";
import ProjectPlanDetail from "./pages/ProjectPlanDetail";
import {SessionContext} from "./util/SessionContext";
import useAppContext from "./util/AppContext";
import MyEnlil from "./pages/MyEnlil";
import AdministrationOrganization from "./pages/AdministrationOrganization";
import AdministrationPosition from "./pages/AdministrationPosition";
import AdministrationRole from "./pages/AdministrationRole";
import AdministrationUserGroup from "./pages/AdministrationUserGroup";
import AdministrationWorkGroup from "./pages/AdministrationWorkGroup";
import AdministrationEmployee from "./pages/AdministrationEmployee";
import SSOLogin from "./components/Login/SSOLogin";
import {DoSomethingWrapper} from "./util/DoSomethingWrapper";

export default function AppRoutes() {
    const location = useLocation();

    const sessionContext = new SessionContext();
    const loggedIn = sessionContext.valid() && location.pathname !== "/logout";

    let content;

    if (loggedIn) {
        if (sessionContext.getURL() !== null && sessionContext.getURL()!.includes("projectPlanUSID") && sessionContext.getURL()!.includes("projectPlanPhaseUSID")) {
            content = (
                <ProjectPlanDetail />
            )
        } else {
            content = (
                <Routes>
                    <Route path="/" element={<ProjectPlan />} />
                    <Route path="/logout" element={<Logout />} />
                    <Route path="/administration" element={<Administration />} />
                    <Route path="/administration/roles" element={<AdministrationRole />} />
                    <Route path="/administration/organizations" element={<AdministrationOrganization />} />
                    <Route path="/administration/positions" element={<AdministrationPosition />} />
                    <Route path="/administration/usergroups" element={<AdministrationUserGroup />} />
                    <Route path="/administration/workgroups" element={<AdministrationWorkGroup />} />
                    <Route path="/administration/users" element={<AdministrationEmployee/>} />
                    <Route path="/project-plan" element={<ProjectPlan />} />
                    <Route path="/myenlil" element={<MyEnlil />} />
                    <Route path="/project-plan/project-plan-detail" element={<ProjectPlanDetail />} />
                    <Route path="/project-plan/project-plan-detail/:projectPlanUSID/:projectPlanPhaseUSID" element={<ProjectPlanDetail />} />

                    <Route path="/" element={<Navigate replace to="/project-plan" />} />

                    <Route path="/*" element={<Navigate to="/" replace state={{
                        referrer: {
                            pathname: location.pathname,
                            search: location.search,
                        },
                    }} />} />
                </Routes>
            )
        }
    }

    if (!loggedIn) {
        if (location.search.includes("projectPlanUSID") && location.search.includes("projectPlanPhaseUSID")) {
            sessionContext.setURL(location.pathname + location.search);
        }
        content = (
            <Routes>
                <Route path="/login" element={<SSOLogin />} />
                <Route path="/logout" element={<Logout />} />
                <Route path="/*" element={(
                    <DoSomethingWrapper>
                        <></>
                    </DoSomethingWrapper>
                )} />
            </Routes>
        )
    }
    return (
        content
    );
}
